export default __webpack_public_path__ + "static/11010-4863aad9747bf68160aad0f2766ee276.jpg";